<template>
  <modal size="xl" @close="$emit('close')">
    <form class="w-full mb-4" @submit.prevent="submit">
      <draggable v-model="order">
        <div
          v-for="(channel, key) in order"
          :key="channel.slug"
          class="bg-grey-0 px-4 py-2 mb-2 border border-blue-3 text-grey-9 rounded cursor-move"
        >{{ key + 1 }}. {{ channel.name }}</div>
      </draggable>
      <p
        v-if="form.errors.has('order')"
        class="text-sm text-red-8 mt-1 pl-1"
      >{{ form.errors.first('order') }}</p>

      <div class="w-full">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"
import draggable from "vuedraggable"

export default {
  name: "ChannelReorderForm",
  components: {
    draggable
  },
  props: {
    category: {
      required: true
    }
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      order: []
    }
  },
  methods: {
    submit() {
      this.$api.channels
        .reorder(this.category.slug, {
          order: this.order.map(value => value.slug)
        })
        .then(() => {
          this.$toasted.success('Channels reordered.')
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else{
            this.$error.generic()
          }
        })
    }
  },
  mounted() {
    this.order = this.category.channels
  }
}
</script>
